import React from "react";

export default function ItemAddonView({ addons, hide_price = false }) {
  const removePriceFromText = (text) => {
    // Matches anything in parentheses like (+$3.00)
    return text.replace(/\s*\(\+\$?.*?\)/, "").trim();
  };

  return (
    <>
      {addons && Object.keys(addons).length > 0 && (
        <div className="cart-item-addons mt-1">
          <ul style={{ paddingLeft: "20px", margin: 0 }}>
            {Object.entries(addons).map(([addon, details]) => (
              <li key={addon} style={{ fontSize: "12px", color: "#555" }}>
                {hide_price ? removePriceFromText(details) : details}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
